import { httpClient } from "@/services";

export default {
	state: {
		trailersValueFilter: null,
		trailersValueList: null,
		trailersValueYears: null,
	},
	mutations: {
		updateTrailersValue(state, payload) {
			state.trailersValueYears = payload.years;
			state.trailersValueFilter = payload.filter;
			state.trailersValueList = payload.trucks;
		}
	},
	actions: {
		async onTrailersValue({ commit }, id) {
			try {
				const { data } = await httpClient.get(`/trailers/value/${ id }`);
				if (data && !data.error) {
					commit('updateTrailersValue', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onTrailersValueRemove({ dispatch }, { id, trailerId }) {
			const { data } = await httpClient.delete(`/trailers/value/${ id }`);

			if (data && data.status) {
				dispatch('setAlert', { type: "success", message: "Remove notes item" });
				dispatch('onTrailersValue', trailerId);
			}
		},
		async onTrailersValueCreate({ dispatch }, { trailerId, values }) {
			const { id } = values;
			const url = id ? `/trailers/value/${ id }/update` : `/trailers/value/${ trailerId }/store`;
			const message = id ? "Updated value item" : "Created value item";

			try {
				const { data } = await httpClient.post(url, values);
				if (data && data.status) {
					dispatch('setAlert', { type: "success", message });
					dispatch('onTrailersValue', trailerId);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async onTrailersValueEdit(context, id) {
			const { data } = await httpClient.get(`/trailers/value/${ id }/edit`);
			if (data && !data.status) {
				return data.values;
			}
		},
	},
	getters: {
		trailersValueFilter: s => s.trailersValueFilter,
		trailersValueList: s => s.trailersValueList,
		trailersValueYears: s => s.trailersValueYears,
	}
};
